export const defaultFormTheme = {
  typography: {
    fontFamily: [
      "Montserrat",
      "BlinkMacSystemFont",
      "Segoe UI",
      "Roboto",
      "Oxygen",
      "Ubuntu",
      "Cantarell",
      "Fira Sans",
      "Droid Sans",
      "Helvetica Neue",
      "sans-serif",
    ].join(", "),
    fontSize: 12,
  },
  palette: {
    primary: {
      main: "#EC9324",
    },
  },
};
